import { gql } from '@apollo/client';

// NOTE: we call them classes in the front end after a change but the backend and databse still use the term courses

export const GET_CLASSES = gql`
query Classes($search: String, $filters: String, $invalidSkuOnly: Boolean) {
  classes(search: $search, filters: $filters, invalidSkuOnly: $invalidSkuOnly) {
    id
    name
    SKU
    program
    classLabel
    level
    timesOfWeek
    teachers {
        id
        name
    }
    courseParticipantCount
    archivedAt
    isHistoric
    skuValidation {
      valid
      issues { index segment value severity message suggestions }
    }
  }
}`;
